import React from "react";
import PropTypes from "prop-types";

import StandardQuoteAndReference from "./StandardQuoteAndReference";
import ComponentMissing from "../../Debug/ComponentMissing";

const QuoteAndReference = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  companyName,
  companyLogo,
  customerName,
  customerPosition,
  customerImage,
  quote,
  reference,
  mirrored,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    companyName,
    companyLogo,
    customerName,
    customerPosition,
    customerImage,
    quote,
    reference,
    mirrored,
    animation,
  };

  function switchQuoteAndReference() {
    switch (layout) {
      case "standard":
        return <StandardQuoteAndReference properties={properties} />;
      default:
        return <ComponentMissing type="QuoteAndReference" subType={layout} />;
    }
  }

  return switchQuoteAndReference();
};

QuoteAndReference.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  companyName: PropTypes.string,
  companyLogo: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  customerName: PropTypes.string,
  customerPosition: PropTypes.string,
  customerImage: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  quote: PropTypes.string,
  reference: PropTypes.string,
  mirrored: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  animation: PropTypes.instanceOf(Object),
};

export default QuoteAndReference;
